import { graphql } from "gql.tada";
import { FileMeta } from 'types'

import type { GqlClient } from '@/types/gqlClient'

export const renameFile = (
  gqlClient: GqlClient,
  fileID: string,
  fileName: string
): Promise<FileMeta> => {
  const query = graphql(`
    mutation ($file_id: uuid!, $file_name: String!) {
      update_files_by_pk(
        pk_columns: { id: $file_id }
        _set: { name: $file_name }
      ) {
        id
        mime_type
        name
        size
        metadata
        updated_at
        uploader {
          account_type
        }
      }
    }
  `)
  return gqlClient
    .request(query, {
      file_id: fileID,
      file_name: fileName,
    })
    .then((data) => {
      if (!data.update_files_by_pk) {
        throw new Error('Failed to rename file')
      }
      return Promise.resolve(data.update_files_by_pk as FileMeta)
    })
}

export const deleteFile = (
  gqlClient: GqlClient,
  fileID: string
): Promise<FileMeta> => {
  const query = graphql(`
    mutation ($file_id: uuid!) {
      update_files_by_pk(
        pk_columns: { id: $file_id }
        _set: { enabled: false }
      ) {
        id
        mime_type
        name
        size
        updated_at
        metadata
        uploader {
          account_type
        }
      }
    }
  `)
  return gqlClient
    .request(query, { file_id: fileID })
    .then((data) => {
      if (!data.update_files_by_pk) {
        throw new Error('Failed to delete file')
      }
      return Promise.resolve(data.update_files_by_pk as FileMeta)
    })
}

export const updateFileMeta = (
  gqlClient: GqlClient,
  fileID: string,
  meta: object
): Promise<FileMeta> => {
  const query = graphql(`
    mutation ($file_id: uuid!, $meta: jsonb!) {
      update_files_by_pk(
        pk_columns: { id: $file_id }
        _set: { metadata: $meta }
      ) {
        id
        mime_type
        name
        size
        updated_at
        metadata
        uploader {
          account_type
        }
      }
    }
  `)
  return gqlClient
    .request(query, {
      file_id: fileID,
      meta: meta,
    })
    .then((data) => {
      if (!data.update_files_by_pk) {
        throw new Error('Failed to update file metadata')
      }
      return Promise.resolve(data.update_files_by_pk as FileMeta)
    })
}
